import { useSnapshot } from 'valtio';

import { userStore } from 'stores/global';

import { getTutorialForIndustryFocus } from '../tutorials';
import TutorialCard from './TutorialCard';

export default function DashboardGettingStarted() {
  const { userInfo } = useSnapshot(userStore.state);

  if (!userInfo.userID) {
    return <TutorialCardLoading />;
  }

  const tutorial = getTutorialForIndustryFocus(userInfo.industryFocus);

  return <TutorialCard {...tutorial} />;
}

function TutorialCardLoading() {
  return (
    <div
      className="border-primary bg-primary flex w-full max-w-[500px] flex-col gap-6 self-start rounded-2xl border p-4 sm:flex-row sm:items-start"
      aria-busy
      aria-live="polite"
    >
      <span className="sr-only">Loading…</span>
      <div className="bg-tertiary aspect-square w-full flex-none animate-pulse rounded-lg sm:w-[225px]" />
      <div className="flex min-w-0 flex-1 flex-col gap-6">
        <div className="flex flex-col gap-2 pb-3">
          <div className="bg-secondary h-5 w-3/4 animate-pulse rounded-lg" />
          <div className="bg-secondary h-4 w-full animate-pulse rounded-lg" />
          <div className="bg-secondary h-4 w-2/5 animate-pulse rounded-lg" />
        </div>
        <div className="flex w-full flex-col items-center gap-3">
          <div className="bg-secondary h-10 w-full animate-pulse rounded-lg" />
          <div className="bg-secondary h-4 w-40 animate-pulse rounded-lg" />
        </div>
      </div>
    </div>
  );
}
